var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24992 8.33333C7.86075 8.33333 9.16659 7.0275 9.16659 5.41667C9.16659 3.80584 7.86075 2.5 6.24992 2.5C4.63909 2.5 3.33325 3.80584 3.33325 5.41667C3.33325 7.0275 4.63909 8.33333 6.24992 8.33333Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7499 8.33333C15.3607 8.33333 16.6666 7.0275 16.6666 5.41667C16.6666 3.80584 15.3607 2.5 13.7499 2.5C12.1391 2.5 10.8333 3.80584 10.8333 5.41667C10.8333 7.0275 12.1391 8.33333 13.7499 8.33333Z",
    fill: "#6C6C6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 11.6667V17.5H4.58341C3.78341 17.5 3.05008 17.175 2.52508 16.6417C1.99175 16.1167 1.66675 15.3833 1.66675 14.5833C1.66675 12.975 2.97508 11.6667 4.58341 11.6667H12.5001Z",
    fill: "#DBDBDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 14.5833C18.3333 16.1917 17.025 17.5 15.4167 17.5H8.75C10.3583 17.5 11.6667 16.1917 11.6667 14.5833C11.6667 13.7833 11.3417 13.05 10.8083 12.525C10.2833 11.9917 9.55 11.6667 8.75 11.6667H15.4167C17.025 11.6667 18.3333 12.975 18.3333 14.5833Z",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.eda4ae4046a99123688dcaf01e35924d.svg";
export { ForwardRef as ReactComponent };